import reducer from './reducers';

export { default as categorySelectors } from './selectors';
export { default as categoryOperations } from './operations';
export { default as categoryTypes } from './types';

export default reducer;
